import React, { useContext, useEffect, useRef, useState } from 'react'
import { AuthContext } from '../../Context/AuthContext/AuthContext'
import { ProgressSpinner } from 'primereact/progressspinner';
import { Navigate, Route, Routes } from 'react-router-dom';

import { rutasDashboard } from '../../../Router/Routes';
import { getPermisos } from '../../API/Users/UserRequests';
import { Splitter, SplitterPanel } from 'primereact/splitter';

import '../../Components/Panel/_PanelSlider.scss'
import '../../Components/Panel/_Panel.scss'
import '../../Components/Panel/_Dashboard.scss'
import PanelSlider from '../../Components/Panel/PanelSlider';
import Footer from '../../Components/Footer/Footer';
import ModalDieSession from '../../Components/Panel/ModalDieSession';

const DashboarRouter = () => {

    const splitterPanel = useRef();
    const splitterContent = useRef();
    const sidebar = useRef();

    const { userAuth } = useContext(AuthContext);
    const { isLogged } = userAuth;
    const [userPermisions, setUserPermisions] = useState([])


    const obtenerPermisos = async (IdUser) => {
        const resp = await getPermisos(IdUser);
        const tempo = resp.permisos.split(',').map((item) => parseInt(item))
        setUserPermisions(tempo);
    }

    useEffect(() => {
        if (isLogged) {
            obtenerPermisos(userAuth?.idUser);
        }
    }, [userAuth])



    const setRouter = () => {
        if (userPermisions.length > 0) {

            const rutas = rutasDashboard.filter((r) => userPermisions.includes(r.permiso));
            return (
                <Routes key={'router'} className='routers' style={{ overflowY: 'hidden' }}>
                    {
                        rutas.map((r) => {
                            return <Route key={r?.path + r?.permiso} path={`${process.env.REACT_APP_ENV}/${r?.path}`} element={r?.element} />
                        })
                    }
                    {/* {userPermisions.map((r) => {
                        const [menu] = rutasDashboard.filter((m) => m.permiso === r);
                        if (menu) {
                            return <Route key={menu?.path + menu?.permiso} path={`${process.env.REACT_APP_ENV}/${menu?.path}`} element={menu?.element} />
                        } else {
                            return null;
                        }
                    })} */}
                    <Route path="*" element={<Navigate from="*" to={`${process.env.REACT_APP_ENV}/Home`} />} />
                </Routes>
            )
        } else {
            return (
                <div>
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                        <ProgressSpinner />
                    </div>
                </div>
            )
        }
    }

    const resizable = ({ sizes }) => {
        const sidebar = document.getElementById('sidebar');
        const svg = document.getElementById('svgBtnCollapse');
        if (window.outerWidth <= 1024) {
            if (sizes[0] <= 15.5) {
                sidebar.classList.add('collapsed')
                svg.classList.remove('active');
            } else {
                sidebar.classList.remove('collapsed')
                svg.classList.add('active')
            }
        } else {
            if (sizes[0] <= 11) {
                sidebar.classList.add('collapsed')
                svg.classList.remove('active');
            } else {
                sidebar.classList.remove('collapsed')
                svg.classList.add('active')
            }
        }
    }

    return (
        <div style={{ width: '100vw', height: '100vh' }}>
            <div className="layout has-sidebar fixed-sidebar fixed-header">
                <Splitter style={{ width: '100%', height: '100%' }} onResizeEnd={resizable} >
                    <SplitterPanel ref={splitterPanel} id='splitterPanel' size={15} minSize={4} className="panel splitterPanel">
                        <aside id="sidebar" ref={sidebar} className="dashbordard__contenedor dashbordard__contenedor-panel sidebar">
                            <div className="sidebar-layout ">
                                <PanelSlider />
                            </div>
                        </aside>
                        <div id="overlay" className="overlay"></div>
                    </SplitterPanel>
                    <SplitterPanel ref={splitterContent} id='splitterContent' size={85} minSize={75} className='splitterContent'>
                        <div className="col12" style={{ width: '100%', overflow: 'hidden' }}>
                            <main className="content dashbordard__contenedor-content col-12">
                                {setRouter()}
                            </main>
                        </div>
                    </SplitterPanel>
                </Splitter>

            </div>
            <Footer />
            <ModalDieSession />
        </div>
    )
}

export default DashboarRouter